import { MonitoringService } from "@gen/tsam/v1/monitoring_pb";
import { client } from "./config";

export async function getVersion() {
  return await client(MonitoringService).health({});
}
